import { Injectable } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Chunk } from "@shared/components/infinite-scroll/infinite-scroll.component";
import { ItemsDataFetcherService } from "@shared/services/item-feed/items-data-fetcher.service";
import { Observable } from "rxjs";
import { LabelingReviewService } from "../labeling-task-review/services/labeling-review.service";
import { LabelingService } from "./labeling.service";

@UntilDestroy()
@Injectable()
export class LabelingReviewDocumentsDataFetcherService extends ItemsDataFetcherService {
    labelingTaskId: string;

    constructor(private labelingService: LabelingService, private labelingReviewService: LabelingReviewService) {
        super();

        this.labelingService.labelingTaskInfo$.pipe(untilDestroyed(this)).subscribe((info) => {
            this.refetchData();
            this.labelingTaskId = info.labelingTaskId;
            this.projectKey = info.projectKey;
        })

        this.labelingReviewService.recordIds$.pipe(untilDestroyed(this)).subscribe(() => {
            this.refetchData();
        });
    }

    updateItem(index: number, item: any): void {
        super.updateItem(index, item);
        this.labelingReviewService.updateCurrentReviewRecord(item);
    }

    getChunk(offset: number): Observable<Chunk> {
        return this.labelingReviewService.getChunk(offset, this.CHUNK_SIZE);
    }
}